import { TGetContext, TOnlineBank } from '@api/lendingAPI/lapi.types';

type TOnlineBankWithProvider = TOnlineBank & {
    provider: 'truelayer' | 'finapi';
};

const inferProvider = (bankId: string): 'truelayer' | 'finapi' => {
    if (bankId.startsWith('xs2a-') || bankId.startsWith('ob-')) {
        return 'truelayer';
    }
    // Finapi banks always have a number as bank_id
    if (/^\d+$/.test(bankId)) {
        return 'finapi';
    }
    throw new Error(`Unknown provider for bank_id: ${bankId}`);
};

export const getBanksFromContext = (context: TGetContext['data']) => {
    if (!context) return [];

    const deOrderedBanks =
        context.open_banking.de_ordered_open_banking_providers;
    if (deOrderedBanks && deOrderedBanks.length > 0) {
        return deOrderedBanks.map(
            (bank): TOnlineBankWithProvider => ({
                ...bank,
                provider: inferProvider(bank.bank_id)
            })
        );
    }

    const truelayerBanks: TOnlineBankWithProvider[] = (
        context.open_banking.truelayer_banks ?? []
    ).map((bank) => ({ ...bank, provider: 'truelayer' as const }));

    const finapiBanks: TOnlineBankWithProvider[] = (
        context.open_banking.finapi_banks ?? []
    ).map((bank) => ({ ...bank, provider: 'finapi' as const }));

    return [...truelayerBanks, ...finapiBanks];
};
